module.exports = __webpack_public_path__ + "static/media/imgWrite.4ea0f1e4.svg";